export function createFeenyAction(apiCall) {
  return function(...args) {
    return {
      feeny: {
        apiCall,
        args,
      },
    };
  };
}
